import React from 'react';

import { Snippet } from '@distribute/shared/types';

import { Button, ButtonSquare, Dropdown, Icon } from '../../../shared/ui';
import { snippetItemIconByType } from '../../../entities/snippets';

import { IconMap } from '../../../shared/sprite';

import * as DropdownMenu from '@radix-ui/react-dropdown-menu';

import { SnippetPreview } from '../../../features/snippets';

import { CreatedBy } from '../../../entities/user';
import { useSnippetAction } from '../hooks';

type Props = {
  snippet: Snippet;
};

export const SnippetCard: React.FC<Props> = ({ snippet }) => {
  const { handleEditSnippet, handlePreviewSnippet, snippetOptions } =
    useSnippetAction({ snippet });

  return (
    <div className="flex flex-col gap-y-3 p-3 border border-gray-300 rounded-xl group hover:shadow-md">
      <div className="cursor-pointer relative flex items-center justify-center overflow-hidden h-41 rounded-md">
        <div className="absolute z-10 flex flex-col items-center justify-center w-full h-full gap-2 transition-all duration-100 ease-linear opacity-0 group-hover:opacity-100 sm:hidden">
          {snippet.isDraft ? (
            <Button
              variant="text"
              color="primary"
              className="w-45 !h-11 text-md !font-semibold"
              onClick={() => handleEditSnippet(snippet)}
            >
              <Icon glyph={IconMap.Edit02} width={20} className="mr-1" />
              Edit draft
            </Button>
          ) : (
            <Button
              variant="text"
              color="secondary"
              className="w-45 !h-9 text-sm !font-semibold"
              onClick={() => handlePreviewSnippet(snippet)}
            >
              <Icon glyph={IconMap.Eye} width={20} className="mr-1" />
              Preview
            </Button>
          )}
        </div>
        <SnippetPreview snippet={snippet} />
      </div>
      <div className="flex flex-nowrap items-center gap-x-2">
        <Icon
          glyph={snippetItemIconByType[snippet.type]}
          width={20}
          className="text-gray-600 flex-shrink-0"
        />
        <p className="font-semibold truncate text-md">
          {snippet.name || 'Untitled'}
        </p>
      </div>
      <div className="flex items-center justify-between">
        <CreatedBy
          displayName={snippet.owner.displayName}
          photoUrl={snippet.owner.photoUrl}
        />
        <div onClick={(e) => e.stopPropagation()}>
          <Dropdown
            side="bottom"
            align="start"
            listStyles="shadow-lg w-45"
            triggerComponent={
              <DropdownMenu.Trigger asChild>
                <ButtonSquare
                  size="sm"
                  variant="tertiary-gray"
                  className="focus:outline-none"
                >
                  <Icon glyph={IconMap.DotsVertical} width={20} />
                </ButtonSquare>
              </DropdownMenu.Trigger>
            }
            items={snippetOptions}
          />
        </div>
      </div>
    </div>
  );
};
